import React from 'react';

import SecuritySectionOrnament from '../../../assets/svg-components/security/heading_section_bottom.svg';
import SecurityCardIllustration from '../../../assets/svg-components/security/triangle_pattern.svg';
import CircularProgress from '../../../components/circular-progress/circlular-progress';
import { SectionContent } from '../../../components/section/section-content';
import { SectionHero } from '../../../components/section/section-hero';
import { SectionTitle } from '../../../components/section/section-title';
import { Translate } from '../../../components/translate';
import SecurityCard from './security-card';
import './security-section.scss';

interface SecuritySectionProps {
  score?: number;
  domain?: string;
}

const SecuritySection: React.FC<SecuritySectionProps> = ({ score, domain }) => {
  return (
    <React.Fragment>
      <SectionHero className="rc-security-section rc-security-section-hero">
        <img src="https://www.siteground.com/static/en/img/recap2023/03_BG.png" alt="security section image" />

        <SectionTitle className="rc-security-section__title">
          {domain ? (
            <Translate id="translate.personal.security.section.title" values={{ website: domain }} />
          ) : (
            <Translate id="translate.security.section.title" />
          )}
        </SectionTitle>

        <SecuritySectionOrnament className="rc-security-section-hero__ornament" />
      </SectionHero>

      <SectionContent size="large" className="rc-security-section">
        <SecurityCard
          className="rc-security-card--score"
          title={
            score ? (
              <Translate id="translate.personal.security.card.security.score.title" values={{ value: score }} />
            ) : (
              <Translate id="translate.security.card.security.score.title" />
            )
          }
          text={
            score ? (
              <Translate id="translate.personal.security.card.security.score.text" values={{ value: score }} />
            ) : (
              <Translate id="translate.security.card.security.score.text" />
            )
          }
          loader={
            <CircularProgress
              filledColor="#DF7DFF"
              unfilledColor="#383BCB"
              value={score || 70}
              valueSuffix="%"
              animationName="security-card-score"
            />
          }
        />

        <SecurityCard
          className="rc-security-card--malicious"
          title={<Translate id="translate.security.card.malicious.requests.title" />}
          text={<Translate id="translate.security.card.malicious.requests.text" />}
          loader={
            <CircularProgress
              filledColor="#DF7DFF"
              unfilledColor="#DF7DFF"
              increment={10}
              value={670}
              enableAnimation={false}
              valueSuffix=" M"
              animationName="security-card-malicious"
            />
          }
        />

        <SecurityCard
          className="rc-security-card--spam"
          title={<Translate id="translate.security.card.spam.blocked.title" />}
          text={<Translate id="translate.security.card.spam.blocked.text" />}
          loader={
            <CircularProgress
              filledColor="#DF7DFF"
              unfilledColor="#DF7DFF"
              animationSpeed={100}
              value={12}
              valueSuffix=" M"
              animationName="security-card-spam"
            />
          }
        />
        <SecurityCard
          className="rc-security-card--srs"
          title={<Translate id="translate.security.card.email.forwarding.title" />}
          text={<Translate id="translate.security.card.email.forwarding.text" />}
          loader={
            <CircularProgress
              filledColor="#DF7DFF"
              unfilledColor="#22257E"
              value={100}
              valueSuffix="%"
              animationName="security-card-srs"
            />
          }
        />

        <SecurityCard
          className="rc-security-card--vulnerabilities"
          title={<Translate id="translate.security.card.vulnerabilities.title" />}
          text={<Translate id="translate.security.card.vulnerabilities.text" />}
          loader={
            <CircularProgress
              filledColor="#DF7DFF"
              unfilledColor="#DF7DFF"
              value={5}
              valueSuffix="+"
              animationSpeed={100}
              animationName="security-card-vulnerabilities"
            />
          }
        >
          <SecurityCardIllustration className="rc-security-card--vulnerabilities_illustration" />
        </SecurityCard>
      </SectionContent>
    </React.Fragment>
  );
};

export default SecuritySection;
